import { WebhookError } from '../utils/error';
import { supabase } from '../lib/supabase';
import { logger } from '../utils/logger';
import { withRetry } from '../utils/network';

export async function triggerMakeWebhook(reportId: string): Promise<void> {
  try {
    logger.info('Triggering webhook via Edge Function', { reportId });

    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
      throw new WebhookError('Authentication required');
    }

    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/trigger-make-webhook`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`,
          'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        },
        body: JSON.stringify({ reportId })
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new WebhookError(error.error || 'Webhook request failed', reportId);
    }

    await response.json();
    logger.info('Webhook triggered successfully', { reportId });
  } 
  catch (error) {
    logger.error('Failed to trigger webhook', error, { reportId });
    await updateReportStatus(reportId, 'failed');
    throw error;
  }
}

async function updateReportStatus(reportId: string, status: 'failed' | 'pending') {
  try {
    const { error } = await supabase
      .from('reports')
      .update({ status })
      .eq('id', reportId);

    if (error) {
      logger.error('Failed to update report status', error, { reportId, status });
    }
  } catch (err) {
    logger.error('Error updating report status', err, { reportId, status });
  }
}